import React from 'react'

import { FaCheck } from 'react-icons/fa';

import why_us2 from '../assets/images/stocks-3.jpg'

import Header from './templates/Header';
import Footer from './templates/Footer';
import SEO from './templates/SEO';
import Stats from './templates/Stats';


function Why_Us() {
  return (
    <div>
      <SEO title="Why Us Page"/>

<Header/>


<div class="aboutarea__2 sp_top_30">
            <div class="container">
                <div class="row">
                    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 aos-init aos-animate" data-aos="fade-up">
                        <div class="about__right__wraper__2">
                            <div class="educationarea__img" data-tilt="" >
                                <img loading="lazy" class="aboutarea__2__img__1 w-100 ms-0" src={why_us2} alt="education"/>
                                {/* <img loading="lazy" class="aboutarea__2__img__2 w-100" src={why_us2} alt="education"/> */}
                             
                            </div>
                            <div class="aboutarea__2__text">
                                <div class="aboutarea__counter">
                                    <span class="counter">90</span> %
                                </div>

                                <p>Profitable Traders</p>


                            </div>
                        </div>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 aos-init aos-animate" data-aos="fade-up">

                        <div class="aboutarea__content__wraper">
                            <div class="aboutarea__button">
                                <div class="default__small__button">Why Us</div>
                            </div>
                            <div class="aboutarea__headding heading__underline">
                                <h2>Our Specialities</h2>
                            </div>
                            <div class="aboutarea__para aboutarea__para__2">
                                <p>At Trading Whales, We’re here to help traders unlock their Trading Potential and make them Professional Traders. With over 10 Years of Successful Trading Experience. We’ve Guided Over 2000+ students to become a Skilled Trader & the Knowledge needed for Lasting Success. Our Top- Notch Mentorship provide Advanced Technical Knowledge, paving the path to Financial Independence.</p>
                            </div>
                            <div class="aboutarea__list__2">
                                <ul>
                                    <li>
                                        <FaCheck style={{color:'green'}}/> &nbsp; Rapid Growth -  Compound Your Investment
                                    </li>

                                    <li>
                                    <FaCheck style={{color:'green'}}/> &nbsp;Beginner Friendly -  Easy for Newbies
                                    </li>

                                    <li>
                                    <FaCheck style={{color:'green'}}/> &nbsp; Trending Techniques -  Updated strategies
                                    </li>
                                </ul>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>

<Stats/>



<Footer/>

    </div>
  )
}

export default Why_Us
